import {
  Dropdown,
  DropdownItem,
  DropdownList,
  Table,
  TableData,
  TableRow
} from '@cokitchen/cokitchen-components';
import React, { useState, useEffect } from 'react';
import { formatCurrency, handleApiError } from 'utils/functions';
import './styles.scss';
import SearchInput from 'components/base/search-input';
import useDashboardContext from 'contexts/dashboard.context';
import { apiService } from 'services/base.service';
import { ArrowRightIcon, FilterAltIcon } from 'cokitchen-icons';
import { MonthlyBreakDownDataType } from 'models/statements.model';
import { DepartmentType } from 'models/department.model';

type Props = {
  loading: boolean;
  data: MonthlyBreakDownDataType[];
  filteredData: MonthlyBreakDownDataType[];
  setFilteredData: (data: MonthlyBreakDownDataType[]) => void;
  setSpender: (value: string) => void;
  setDepartmentId: (value: string) => void;
  pageCount: number;
  getSelectedPage: (val: { selected: number }) => Promise<void>;
};
const InsightTable = ({
  loading,
  data,
  filteredData,
  setFilteredData,
  setSpender,
  setDepartmentId,
  pageCount,
  getSelectedPage
}: Props) => {
  const { activeCompany } = useDashboardContext();
  const companyId = activeCompany?.id;
  const [departmentList, setDepartmentList] = useState<DepartmentType[]>([]);
  const [showFilterList, setShowFilterList] = useState<boolean>(false);
  const [showDepartmentList, setShowDepartmentList] = useState<boolean>(false);
  const getDepartments = async () => {
    if (!companyId) return;
    try {
      const res = await apiService.get(`department/company/${companyId}`);
      setDepartmentList(res?.data?.data);
    } catch (err) {
      handleApiError(err);
    }
  };

  useEffect(() => {
    getDepartments();
  }, [companyId]);
  const options = [
    { name: 'Top Spenders', value: 'most' },
    { name: 'Least spenders', value: 'least' }
  ];
  const [filter, setFilter] = useState('');
  const [value, setValue] = useState('');

  const header = ['Name', 'Dept', 'Budget', 'Spent'];

  useEffect(() => {
    const filtered = data.filter(
      (people) =>
        people.first_name.toLocaleLowerCase().includes(value.toLocaleLowerCase()) ||
        people.last_name.toLocaleLowerCase().includes(value.toLocaleLowerCase())
    );
    setFilteredData(filtered);
  }, [value]);
  return (
    <div>
      <div className='flex justify-between mb-[34px]  mt-[50px] header'>
        <div>
          <Dropdown
            visible={showFilterList}
            onClickOutside={() => setShowFilterList(false)}
            content={
              <div
                className='flex justify-between items-center min-w-[150px] border border-[#E5E6E6] rounded-md p-2 text-[#5E6164] text-sm gap-2 cursor-pointer h-[36px]'
                onClick={() => setShowFilterList(true)}>
                {filter || 'All'}
                <FilterAltIcon />
              </div>
            }>
            <DropdownList>
              <DropdownItem
                onClick={() => {
                  setFilter('');
                  setSpender('');
                  setDepartmentId('');
                  setShowFilterList(false);
                }}>
                All
              </DropdownItem>
              <DropdownItem>
                <Dropdown
                  visible={showDepartmentList}
                  onClickOutside={() => {
                    setShowDepartmentList(false);
                    setShowFilterList(false);
                  }}
                  placement='right'
                  content={
                    <div
                      className='flex justify-between items-center w-full gap-6 text-[#212224] text-sm'
                      onClick={() => setShowDepartmentList(true)}>
                      Departments
                      <ArrowRightIcon />
                    </div>
                  }>
                  <DropdownList>
                    {departmentList.map((item, index) => (
                      <DropdownItem
                        key={index}
                        onClick={() => {
                          setFilter(item.name);
                          setShowDepartmentList(false);
                          setShowFilterList(false);
                          setDepartmentId(item.id);
                          setSpender('');
                        }}>
                        {item.name}
                      </DropdownItem>
                    ))}
                  </DropdownList>
                </Dropdown>
              </DropdownItem>
              {options.map((item, index) => (
                <DropdownItem
                  key={index}
                  onClick={() => {
                    setFilter(item.name);
                    setShowFilterList(false);
                    setSpender(item.value);
                    setDepartmentId('');
                  }}>
                  {item.name}
                </DropdownItem>
              ))}
            </DropdownList>
          </Dropdown>
        </div>
        <SearchInput value={value} handleChange={(e) => setValue(e.target.value)} />
      </div>
      {filteredData.length === 0 ? (
        <div className='flex justify-center items-center'>
          <p className='text-center'>No data found</p>
        </div>
      ) : (
        <Table
          headers={header}
          loading={loading}
          pageCount={pageCount}
          onPageChange={getSelectedPage}>
          {filteredData.map(({ first_name, last_name, budget, spent, department }, index) => (
            <TableRow className='text-sm font-medium' key={index}>
              <TableData>
                <p className='cursor-pointer capitalize'>
                  {first_name} {last_name}
                </p>
              </TableData>
              <TableData>
                <p className='capitalize font-normal text-sm text-[#5E6164]'>{department}</p>
              </TableData>
              <TableData>
                {formatCurrency(budget, {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0
                })}
              </TableData>
              <TableData>
                {formatCurrency(spent, {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0
                })}
              </TableData>
            </TableRow>
          ))}
        </Table>
      )}
    </div>
  );
};

export default InsightTable;
